export default __webpack_public_path__ + "static/assets/c2ee70832065fe63d2e11eba9fd1a809.png";